let inject = ['$scope', '$uibModalInstance','product', 'ngAuthSettings', 'SharedService', '$timeout','$mdToast'];

class ModalRecommendProductController {
  constructor ($scope,$uibModalInstance,product, ngAuthSettings, SharedService, $timeout,$mdToast) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.SharedService = SharedService;
    this.$uibModalInstance = $uibModalInstance;
    this.ngAuthSettings = ngAuthSettings;
    this.product = Object.assign({}, product);
    this.mailSent = false;
    this.$mdToast = $mdToast;
    this.contactDataForm = {};
  }

  sendMailContact(){

    if (this.contactForm.$valid) {
      this.sendingMail=true;
      this.contactDataForm.productName = this.product.name;

      this.contactDataForm.productUrl = window.__env.frontPath + this.product.category.slug + '/' + this.product.slug;

      this.SharedService.sendMailContact(this.contactDataForm).then(response => {
        if (!response.error) {
          if(__env.adaptative){
              var mdToast=this.$mdToast;
              var that=this;
            this.ok();
              this.$mdToast.show({
                hideDelay   : 8000,
                controller  : function () {
                  this.closeToast = function(){
                    mdToast.hide();
                  }

                },
                controllerAs:'toast',
                template : '<md-toast>\n' +
                '  <span class="md-toast-text">El correo ha sido enviado exitosamente. Gracias por recomendar el producto'+
                that.product.name + ' - Referencia ' + that.product.reference +'</span>\n' +
                '  <md-button ng-click="toast.closeToast()">\n' +
                '    Cerrar\n' +
                '  </md-button>\n' +
                '</md-toast>'
              });

          }else{
            this.mailSent = true;
            this.$timeout(() => {
              this.ok();
            }, 8000);
          }


        }
      }).catch(reason => {

      });
    }
    else {
      this.contactForm.$error.required.forEach(field =>  {
        field.$setDirty();
      });
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalRecommendProductController.$inject = inject;

export default ModalRecommendProductController;



// WEBPACK FOOTER //
// ./www/components/shared/components/modal-recommend-product/modal-recommend-product.controller.js